import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { LeadXChangeRoutes } from '../../../routes/HomeRoutes/LeadXChangeRoutes';

export const LeadXChangeLayout = () => (
  <SwitchRoute routes={LeadXChangeRoutes} />
);
